import axios from 'axios'

export default {
  search: function (request) {
    return axios.get('/api/journalpmpk/search', { params: request });
  },
  find: function (id) {
    return axios.get(`/api/journalpmpk/${id}`);
  },
  create: function (data) {
    return axios.post('/api/journalpmpk', data);
  },
  update: function (id, data) {
    return axios.put(`/api/journalpmpk/${id}`, data);
  },
  saveEdu: function (id, data, eduType) {
    return axios.put(`/api/journalpmpk/${id}/Education/${eduType}`, data);
  },  
  saveEmployments: function (id, data) {
    return axios.put(`/api/journalpmpk/${id}/Employment`, data);
  }, 
  saveConclusion: function (id, data) {
    return axios.put(`/api/journalpmpk/${id}/Conclusion`, data);
  }, 
  saveDocuments: function (id, data) {
    return axios.put(`/api/journalpmpk/${id}/SiprIomAop`, data);
  },        
  delete: function (id) {
    return axios.delete(`/api/journalpmpk/${id}`);
  },
  archiveConclusion(id) {
    return axios.post(`/api/journalpmpk/archiveconclusion/${id}`);
  },
  restoreConclusion(id) {
    return axios.post(`/api/journalpmpk/restoreconclusion/${id}`);
  },
  findConclusion(id) {
    return axios.get(`/api/journalpmpk/${id}/Conclusion`);
  }
}